import { Reducer } from 'redux';
import { PaymentState, PaymentActionTypes } from 'types';

const initialState: PaymentState = {};

const reducer: Reducer<PaymentState> = (state = initialState, action: any) => {
  switch (action.type) {
    case PaymentActionTypes.CREATE_CHECKOUT_SESSION_START: {
      return {
        ...state,
        checkoutSessionSecret: undefined,
        postPaymentId: undefined,
        checkingOut: true,
        error: undefined
      };
    }
    case PaymentActionTypes.CREATE_CHECKOUT_SESSION_SUCCESS: {
      return {
        ...state,
        checkoutSessionSecret: !action.payload.completed
          ? action.payload.clientSecret
          : undefined,
        postPaymentId:
          !action.payload.clientSecret && !!action.payload.completed
            ? Number(action.payload.postPaymentId)
            : undefined,
        checkingOut: false,
        error: undefined
      };
    }
    case PaymentActionTypes.CREATE_CHECKOUT_SESSION_FAILURE: {
      return {
        ...state,
        checkoutSessionSecret: undefined,
        checkingOut: false,
        error: action.payload
      };
    }
    case PaymentActionTypes.GET_PAYMENT_TYPE_PRICE_START: {
      return {
        ...state,
        gettingPaymentTypePrice: true,
        paymentTypePrice: undefined,
        error: undefined
      };
    }
    case PaymentActionTypes.GET_PAYMENT_TYPE_PRICE_SUCCESS: {
      return {
        ...state,
        gettingPaymentTypePrice: false,
        paymentTypePrice: action.payload.unitAmount,
        priceIncludeTax: action.payload.includeTax,
        error: undefined
      };
    }
    case PaymentActionTypes.GET_PAYMENT_TYPE_PRICE_FAILURE: {
      return {
        ...state,
        gettingPaymentTypePrice: false,
        error: action.payload
      };
    }
    case PaymentActionTypes.CHECK_CHECKOUT_SESSION_STATUS_START: {
      return {
        ...state,
        checkoutSessionStatus: undefined,
        checkingCheckoutSessionStatus: true,
        error: undefined
      };
    }
    case PaymentActionTypes.CHECK_CHECKOUT_SESSION_STATUS_SUCCESS: {
      return {
        ...state,
        checkoutSessionStatus: action.payload.status,
        paymentIntentId: action.payload.paymentIntentId,
        checkingCheckoutSessionStatus: false,
        error: undefined
      };
    }
    case PaymentActionTypes.CHECK_CHECKOUT_SESSION_STATUS_FAILURE: {
      return {
        ...state,
        checkoutSessionStatus: undefined,
        checkingCheckoutSessionStatus: false,
        error: action.payload
      };
    }
    case PaymentActionTypes.CONFIRM_POST_PAYMENT_START: {
      return {
        ...state,
        confirmingPostPayment: true,
        postPaymentConfirmed: undefined,
        error: undefined
      };
    }
    case PaymentActionTypes.CONFIRM_POST_PAYMENT_SUCCESS: {
      return {
        ...state,
        confirmingPostPayment: false,
        postPaymentConfirmed: true,
        error: undefined
      };
    }
    case PaymentActionTypes.CONFIRM_POST_PAYMENT_FAILURE: {
      return {
        ...state,
        confirmingPostPayment: false,
        postPaymentConfirmed: undefined,
        error: action.payload
      };
    }
    case PaymentActionTypes.CLEAR_PAYMENT_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export { reducer as PaymentReducer };
